import { styled } from '@mui/material/styles';
import { keyframes } from '@mui/system';
import { Box, Typography, Button, Divider } from '@mui/material';

const fadeOut = keyframes`
  0% {
    opacity: 1;
    filter: blur(0);
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    filter: blur(10px);
  }
`;

const cloudyFadeIn = keyframes`
  0% {
    opacity: 0;
    filter: blur(10px);
  }
  100% {
    opacity: 1;
    filter: blur(0);
    transform: translateX(0);
  }
`;

export const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  bgcolor: 'white',
  width: '100%',
  height: '100vh',
  maxHeight: 'calc(100vh - 40px)',
  padding: '12px 15px 0',
  minHeight: '550px',
});

export const GetStartedText = styled(Typography)({
  color: '#475467',
  fontSize: 'clamp(18px, 5vw, 27px)',
  textAlign: 'center',
  fontWeight: 400,
  lineHeight: '20px',
});

export const SweepStakeTitle = styled(Typography)({
  fontSize: '20px',
  fontWeight: 700,
  lineHeight: '24px',
  textAlign: 'center',
  paragraph: '24px',
  color: '#475467',
  margin: '8px 8px',
});

export const SweepStakeDescription = styled(Typography)({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  textAlign: 'center',
  paragraph: '20px',
  color: '#475467',
  marginBottom: '16px',
});

export const TopTextContainer = styled(Box)({
  alignItems: 'center',
  opacity: 1,
  transition: 'opacity 0.5s ease-in-out',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '34px 14px',
  borderRadius: '12px',
});

export const TitleContainer = styled(Box)({
  alignItems: 'center',
  opacity: 1,
  transition: 'opacity 0.5s ease-in-out',
  backdropFilter: 'blur(10px)',
  backgroundColor: 'rgba(255, 255, 255, 0.4)',
  border: '1px solid #2D11AD',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '34px 14px',
  borderRadius: '12px',
  height: '242px',
});

export const Hidden = styled(Box)({
  opacity: 0,
});

export const Title = styled(Typography)({
  fontSize: 'clamp(38px, 10vw, 48px)',
  fontWeight: 650,
  color: 'white',
  whiteSpace: 'nowrap',
});

export const AccountName = styled(Typography)({
  fontWeight: 600,
  fontSize: 'clamp(18px, 6.6vw, 28px)',
  lineHeight: '30px',
  color: 'white',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  marginTop: '30px',
});

export const SubTitle = styled(Typography)({
  fontSize: 'clamp(20px, 4vw, 20px)',
  fontWeight: 650,
  color: '#2D11AD',
  textAlign: 'center',
});

export const ContentContainer = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const QuestionsContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  transition: 'opacity 0.5s ease-in-out',
});

export const MainMessageTitle = styled(Typography)({
  fontSize: 'clamp(16px, 4.48vw, 24px)',
  color: '#2D11AD',
  textAlign: 'center',
  fontWeight: '700',
  lineHeight: '4.5vh',
  opacity: '0.8',
});

export const MainMessageText = styled(Typography)({
  fontSize: 'clamp(16px, 4.48vw, 24px)',
  color: '#2D11AD',
  fontWeight: '500',
  textAlign: 'center',
  whiteSpace: 'pre-wrap',
  opacity: '0.8',
});

export const StyledDivider = styled(Divider)({
  width: '255px',
  margin: '2vh 0',
  borderColor: '#E4E4E4',
});

export const BottomText = styled(Typography)({
  fontSize: '12px',
  width: '100%',
  textAlign: 'center',
  color: '#475467',
  marginTop: '2vh',
  whiteSpace: 'pre-wrap',
});

export const ShareButton = styled(Button)({
  fontSize: 'clamp(16px, 4.48vw, 24px)',
  fontWeight: '600',
  color: '#2D11AD',
  borderColor: '#2D11AD',
  '&:hover': {
    color: '#2D11AD',
    borderColor: '#2D11AD',
  },
});

export const Fadein = styled(Box)({
  animation: `${cloudyFadeIn} 1.5s ease-out forwards`,
  opacity: 1,
});

export const Fadeout = styled(Box)({
  animation: `${fadeOut} 1s ease-out forwards`,
  opacity: 1,
});
